import { render, staticRenderFns } from "./AWSCustomer.vue?vue&type=template&id=56413d29&scoped=true&"
import script from "./AWSCustomer.vue?vue&type=script&lang=js&"
export * from "./AWSCustomer.vue?vue&type=script&lang=js&"
import style0 from "./AWSCustomer.vue?vue&type=style&index=0&id=56413d29&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56413d29",
  null
  
)

export default component.exports